import { useEffect, useState } from 'react';
import {
  getPhotoVogueService,
  type PhotoVogueFilterOptions,
} from '@/services/photovogue';

export const useFilterOptions = (
  open: boolean,
  field: keyof PhotoVogueFilterOptions,
) => {
  const [values, setValues] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!open) return;
    let active = true;
    setLoading(true);
    setError(false);
    getPhotoVogueService()
      .getFilterValues(field)
      .then((next) => {
        if (active) setValues(next);
      })
      .catch(() => {
        if (active) setError(true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [open, field, attempt]);
  return {
    values,
    loading,
    error,
    retry: () => setAttempt((value) => value + 1),
  };
};

export const FilterOptionsStatus = ({
  label,
  loading,
  error,
  retry,
}: {
  label: string;
  loading: boolean;
  error: boolean;
  retry: () => void;
}) =>
  loading ? (
    <p role="status" className="text-sm">
      Loading {label}…
    </p>
  ) : error ? (
    <p role="alert" className="text-sm">
      Could not load {label}.{' '}
      <button type="button" className="underline" onClick={retry}>
        Retry
      </button>
    </p>
  ) : null;
